// VehicleInformation.js
import React from 'react';
import './StepQuestionnaire.css';
import './login.css'
import './CreateFirm.css'
function VehicleInformation({ vehicles, setVehicles, labelPrefix }) {
  const addVehicle = () => {
    setVehicles([
      ...vehicles,
      { 
        year: "", 
        make: "", 
        model: "", 
        miles: "", 
        loan: "", 
        creditor: "", 
        loanBalance: "", 
        monthlyPayment: "", 
        currentOnPayments: "", 
        monthsBehind: "",
        keep:""
      }
    ]);
  };

  const updateVehicle = (index, field, value) => {
    const newVehicles = [...vehicles];
    newVehicles[index][field] = value;
    setVehicles(newVehicles);
  };
  const TrashIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="trash-icon" fill="none" viewBox="0 0 24  24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
</svg>

  );
  const deleteVehicle = (index) => {
    const newVehicles = vehicles.filter((_, i) => i !== index);
    setVehicles(newVehicles);
  };

  return (
    <div className="vehicle-section-vehicles">
      <h3>{labelPrefix} Vehicle Information</h3>
      <div style={{ paddingBottom: "15px" }}>include motorcycles and recreational vehicles</div>
      {vehicles.map((vehicle, idx) => (
        <div key={idx} className="vehicle-form-vehicles">
          <div className="vehicle-header">
            <span>{labelPrefix} Vehicle {idx + 1}</span>
            <button className="delete-button" onClick={() => deleteVehicle(idx)}>
                <TrashIcon />
            </button>
          </div>
          <div className="vehicle-grid-vehicles">
            <div className="vehicle-grid-row">
              <input
                type="text"
                inputMode="numeric"
                placeholder="Year"
                pattern="\\d*"
                value={vehicle.year}
                onChange={e => {
                  const val = e.target.value; 
                  if (/^\d*$/.test(val)) {
                  updateVehicle(idx, "year", e.target.value);}
                  }}
              />
              <input
                type="text"
                placeholder="Make"
                value={vehicle.make}
                onChange={(e) => updateVehicle(idx, "make", e.target.value)}
              />
            </div>
            <div className="vehicle-grid-row second">
              <input
                type="text"
                placeholder="Model"
                value={vehicle.model}
                onChange={(e) => updateVehicle(idx, "model", e.target.value)}
              />
              <input
                type="text"
                inputMode="numeric"
                placeholder="Miles"
                value={vehicle.miles}
                onChange={(e) => updateVehicle(idx, "miles", e.target.value)}
              />
            </div>
          </div>
          <div className="binary-options-vehicles">
            <button
              className={`binary-button-vehicles ${vehicle.loan==="paidOff" ? "selected" : ""}`}
              onClick={() => updateVehicle(idx, "loan", "paidOff")}
            >
              Paid Off
            </button>
            <button
              className={`binary-button-vehicles ${vehicle.loan==="loan" ? "selected" : ""}`}
              onClick={() => updateVehicle(idx, "loan", "loan")}
            >
              Loan
            </button>
          </div>
          {vehicle.loan === "loan" && (
            <>
              <input
                type="text"
                placeholder="Creditor"
                value={vehicle.creditor}
                onChange={(e) => updateVehicle(idx, "creditor", e.target.value)}
              />
              <input
                type="text"
                inputmode="numeric"
                placeholder="Loan Balance"
                value={vehicle.loanBalance}
                onChange={(e) => updateVehicle(idx, "loanBalance", e.target.value)}
              />
              <input
                type="text"
                inputmode="numeric"
                placeholder="Monthly Payment"
                value={vehicle.monthlyPayment}
                onChange={(e) => updateVehicle(idx, "monthlyPayment", e.target.value)}
              />
              <div>do you want to keep it?</div>
              <div className="binary-options-vehicles">
              
              <button 
                className={`binary-button-vehicles ${vehicle.keep === "keep" ? "selected" : ""}`}
                onClick={() => updateVehicle(idx, "keep", "keep")}
              >
                Keep
              </button>
              <button 
                className={`binary-button-vehicles ${vehicle.keep === "letGo" ? "selected" : ""}`}
                onClick={() => updateVehicle(idx, "keep", "letGo")}
              >
                Let Go
              </button>
            </div>
            <div>are you current on the payments?</div>
              <div className="binary-options-vehicles">
                <button
                  className={`binary-button-vehicles ${vehicle.currentOnPayments==="yes" ? "selected" : ""}`}
                  onClick={() => updateVehicle(idx, "currentOnPayments", "yes")}
                >
                  Current
                </button>
                <button
                  className={`binary-button-vehicles ${vehicle.currentOnPayments==="no" ? "selected" : ""}`}
                  onClick={() => updateVehicle(idx, "currentOnPayments", "no")}
                >
                  Behind
                </button>
              </div>
              {vehicle.currentOnPayments === "no" && (
                <input
                  type="text"
                  inputmode="numeric"
                  placeholder="Months Behind"
                  value={vehicle.monthsBehind}
                  onChange={(e) => updateVehicle(idx, "monthsBehind", e.target.value)}
                />
              )}
            </>
          )}
        </div>
      ))}
      <button className="action-button" onClick={addVehicle}>Add vehicle</button>
    </div>
  );
}

export default VehicleInformation;